<template>
	<div class="afterSale">
		<div class="btnbox"></div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="" prop="shop_id">
						<el-select v-model="formfilter.shop_id" placeholder="请选择渠道">
							<el-option label="渠道" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="" prop="type">
						<el-select v-model="formfilter.type" placeholder="售后类型">
							<el-option label="全部" value=""></el-option>
							<el-option label="申请取消" value="仅退款"></el-option>
							<el-option label="退货退款" value="退货退款"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="" prop="shop_status">
						<el-select v-model="formfilter.shop_status" placeholder="聚水潭状态">
							<el-option label="全部" value=""></el-option>
							<el-option label="待卖家同意" value="WAIT_SELLER_AGREE"></el-option>
							<el-option label="待买家退货" value="WAIT_BUYER_RETURN_GOODS"></el-option>
							<el-option label="待卖家收货" value="WAIT_SELLER_CONFIRM_GOODS"></el-option>
							<el-option label="退款成功" value="SUCCESS"></el-option>
							<el-option label="退款关闭" value="CLOSED"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="" prop="sync_status">
						<el-select v-model="formfilter.sync_status" placeholder="同步状态">
							<el-option label="全部" value=""></el-option>
							<el-option label="待上传" :value="0"></el-option>
							<el-option label="已上传" :value="1"></el-option>
							<el-option label="同步中" :value="2"></el-option>
							<el-option label="已完成" :value="3"></el-option>
							<el-option label="上传失败" :value="4"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="shop_name" fixed="left" label="渠道名称" align="center" header-align="center" width="120">
					</el-table-column>
					<el-table-column prop="service_id" label="售后单号" align="center" header-align="center" width="180">
					</el-table-column>
					<el-table-column prop="trade_no" label="订单编号" align="center" header-align="center" width="180">
					</el-table-column>
					<el-table-column prop="type_str" label="售后类型" align="center" header-align="center" width="100">
					</el-table-column>
					<el-table-column prop="service_status_str" label="平台状态" align="center" header-align="center" width="100">
					</el-table-column>
					<el-table-column prop="shop_status_str" label="聚水潭状态" align="center" header-align="center" width="120">
					</el-table-column>
					<el-table-column prop="sync_status_str" label="同步状态" align="center" header-align="center" width="100">
					</el-table-column>
					<el-table-column prop="refund_amount" label="退款金额" align="center" header-align="center" width="100">
						<template slot-scope="scope">
							{{(scope.row.refund_amount / 100).toFixed(2)}}
						</template>
					</el-table-column>
					<el-table-column prop="logistics_company" label="退货物流公司" align="center" header-align="center" width="120">
					</el-table-column>
					<el-table-column prop="logistics_no" label="退货物流单号" align="center" header-align="center" width="150">
					</el-table-column>
					<el-table-column prop="warehouse" label="收货仓库" align="center" header-align="center" width="120">
					</el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center" width="160">
					</el-table-column>
					<el-table-column prop="sync_time_str" label="同步时间" align="center" header-align="center" width="160">
					</el-table-column>
					<el-table-column fixed="right" label="操作" align="center" header-align="center" width="100">
						<template slot-scope="scope">
							<el-button type="text" @click="ondetail(scope.row)">详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="page"
					:page-sizes="[20, 50, 100]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>
		<!-- 详情弹窗 -->
		<el-dialog title="售后详情" :visible.sync="detailshow" width="900px" :before-close="ondetailclose">
			<div class="detail-content" v-loading="detailloading">
				<div class="detail-section">
					<h4>平台信息</h4>
					<el-row :gutter="20">
						<el-col :span="8"><span class="label">售后单号：</span><span>{{detail.service_id}}</span></el-col>
						<el-col :span="8"><span class="label">平台状态：</span><span>{{detail.service_status_str}}</span></el-col>
						<el-col :span="8"><span class="label">订单编号：</span><span>{{detail.trade_no}}</span></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8"><span class="label">订单状态：</span><span>{{detail.order_status}}</span></el-col>
						<el-col :span="8"><span class="label">买家收货：</span><span>{{detail.buyer_reject_accept == 1 ? '已收货' : '未收货'}}</span></el-col>
						<el-col :span="8"><span class="label">同意退款：</span><span>{{detail.agree}}</span></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8"><span class="label">同意退款2：</span><span>{{detail.agree2}}</span></el-col>
					</el-row>
				</div>
				<div class="detail-section">
					<h4>聚水潭信息</h4>
					<el-row :gutter="20">
						<el-col :span="8"><span class="label">聚水潭单号：</span><span>{{detail.as_id}}</span></el-col>
						<el-col :span="8"><span class="label">外部单号：</span><span>{{detail.outer_as_id}}</span></el-col>
						<el-col :span="8"><span class="label">售后类型：</span><span>{{detail.type}}</span></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8"><span class="label">聚水潭状态：</span><span>{{detail.jst_status}}</span></el-col>
						<el-col :span="8"><span class="label">平台状态：</span><span>{{detail.shop_status_str}}</span></el-col>
						<el-col :span="8"><span class="label">货物状态：</span><span>{{detail.good_status}}</span></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8"><span class="label">同步状态：</span><span>{{detail.sync_status_str}}</span></el-col>
						<el-col :span="8"><span class="label">退款金额：</span><span>{{detail.refund_amount ? (detail.refund_amount / 100).toFixed(2) : '0.00'}}</span></el-col>
						<el-col :span="8"><span class="label">运费：</span><span>{{detail.freight ? (detail.freight / 100).toFixed(2) : '0.00'}}</span></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8"><span class="label">实付金额：</span><span>{{detail.payment ? (detail.payment / 100).toFixed(2) : '0.00'}}</span></el-col>
						<el-col :span="8"><span class="label">确认时间：</span><span>{{detail.confirm_date}}</span></el-col>
						<el-col :span="8"><span class="label">退货物流：</span><span>{{detail.logistics_company}} {{detail.logistics_no}}</span></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8"><span class="label">收货仓库：</span><span>{{detail.warehouse}}</span></el-col>
					</el-row>
				</div>
				<div class="detail-section">
					<h4>收货信息</h4>
					<el-row :gutter="20">
						<el-col :span="8"><span class="label">收件人：</span><span>{{detail.recv_name}}</span></el-col>
						<el-col :span="8"><span class="label">手机号：</span><span>{{detail.recv_mobile}}</span></el-col>
						<el-col :span="8"><span class="label">地址：</span><span>{{detail.recv_address}}</span></el-col>
					</el-row>
				</div>
				<div class="detail-section">
					<h4>商品明细</h4>
					<el-table :data="detail.details" style="width: 100%" border size="small">
						<el-table-column prop="refund_num" label="退款数量" align="center" width="100"></el-table-column>
						<el-table-column prop="refund_reason" label="退款原因" align="center"></el-table-column>
						<el-table-column prop="product_price" label="单价" align="center" width="100">
							<template slot-scope="scope">
								{{(scope.row.product_price / 100).toFixed(2)}}
							</template>
						</el-table-column>
						<el-table-column prop="product_style_number" label="货号" align="center" width="120"></el-table-column>
						<el-table-column prop="product_size" label="尺码" align="center" width="100"></el-table-column>
					</el-table>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="detailshow = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'jafterSale',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					shop_id: "",
					type: "",
					shop_status: "",
					sync_status: ""
				},
				qudao: [],
				detailshow: false,
				detailloading: false,
				detail: {},
			}
		},
		
		mounted() {
			this.onlist();
			this.onqudao();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		methods: {
			handleCurrentChange() {
				this.onlist();
			},
		
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
		
			onfilter() {
				this.page = 1;
				this.onlist();
			},
		
			onreset() {
				this.formfilter = {
					shop_id: "",
					type: "",
					shop_status: "",
					sync_status: ""
				};
				this.page = 1;
				this.onlist();
			},
		
			onlist() {
				var params = {
					page: this.page,
					pageSize: this.pageSize,
					shop_id: this.formfilter.shop_id,
					type: this.formfilter.type,
					shop_status: this.formfilter.shop_status,
					sync_status: this.formfilter.sync_status
				};
				this.$axios.get('api/jst/after_sale_list', {params: params}).then(res => {
					if (res.data.code == 0) {
						this.list = res.data.data.list;
						this.total = res.data.data.total;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
		
			ondetail(row) {
				this.detailshow = true;
				this.detailloading = true;
				this.$axios.get('api/jst/after_sale_info', {params: {id: row.service_id}}).then(res => {
					if (res.data.code == 0) {
						this.detail = res.data.data;
					} else {
						this.$message.error(res.data.message);
					}
					this.detailloading = false;
				}).catch(err => {
					console.log(err);
					this.detailloading = false;
				});
			},
		
			ondetailclose() {
				this.detailshow = false;
				this.detail = {};
			},
		
			onqudao() {
				this.$axios.get('api/jst/shop_list').then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data;
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.afterSale {
		width: 100%;
		height: calc(100vh - 60px);
		display: flex;
		flex-direction: column;
	}

	.btnbox {
		height: 50px;
	}

	.tablebox {
		flex: 1;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.filterdiv {
		padding: 10px;
		background: #fff;
	}

	.zk {
		text-align: center;
		padding: 5px;
		background: #f5f5f5;
		cursor: pointer;
		span {
			font-size: 12px;
			color: #666;
		}
	}

	.tablediv {
		flex: 1;
		overflow: auto;
		padding: 10px;
		background: #fff;
	}

	.pagination {
		padding: 10px;
		background: #fff;
		text-align: right;
	}

	.detail-content {
		max-height: 600px;
		overflow-y: auto;
	}

	.detail-section {
		margin-bottom: 20px;
		h4 {
			margin: 0 0 12px 0;
			padding: 8px 12px;
			background: #f5f7fa;
			border-left: 3px solid #409eff;
			font-size: 14px;
			color: #333;
		}
		.el-row {
			margin-bottom: 10px;
		}
		.label {
			color: #999;
			margin-right: 4px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/jushuitan/after_sale.vue